const EngagementSectionHeader = () => {
  return (
    <div className="grid grid-cols-12 w-full max-w-[1120px]">
      <div className="col-span-12 flex flex-col space-y-4 text-center md:text-left">
        <span className="mobile-h2 md:h3 lg:h2">Your region of engagement</span>
        <span className="subheading">
          We make sure you arrive at your destination.
        </span>
      </div>
    </div>
  );
};

export default EngagementSectionHeader;
